import { render, staticRenderFns } from "./healthy_format.vue?vue&type=template&id=83a21722&scoped=true"
import script from "./healthy_format.vue?vue&type=script&lang=js"
export * from "./healthy_format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a21722",
  null
  
)

export default component.exports